import { NgForm } from '@angular/forms';
import { AfterContentInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { IPaymentInfo } from '../../models/i-payment-models';
import { PAYMENT_PERSON_TYPES } from '../../payment.constants';
import {
  CustomComponent,
  EMAIL_PATTERN,
  IUserCompany,
  ngHelper
} from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'payment-contact-info',
  templateUrl: './payment-contact-info.component.html',
  styleUrls: ['./payment-contact-info.component.scss']
})
export class PaymentContactInfoComponent extends CustomComponent implements AfterContentInit, OnChanges {
  @Input() userInfo: IPaymentInfo;
  @Input() personType: string;
  @Input() countryCode: string;
  @Input() askUserName = true;
  @Input() askPhone = true;
  @Input() askEmail = true;
  @Input() askForReferenceField = false;
  @Input() showSmsInfo = true;
  @Input() bakeryId: number;
  @Input() useCompanySearcher = false;
  @Input() allowToEditCompany = true;

  @Output() onValidUpdated = new EventEmitter<boolean>();
  @Output() onInfoUpdated = new EventEmitter<IPaymentInfo>();
  @Output() onCompanySelected = new EventEmitter<IUserCompany>();

  public PAYMENT_PERSON_TYPES = PAYMENT_PERSON_TYPES;
  public EMAIL_PATTERN = EMAIL_PATTERN;

  public form: NgForm;

  public isValid: boolean;
  public info: IPaymentInfo = {};
  public showPhone = false;

  constructor() {
    super();
  }

  // This hack is need to avoid error: 'ReferenceError: libphonenumber is not defined'
  ngAfterContentInit() {
    setTimeout(() => this.showPhone = this.askPhone);
  }

  ngOnChanges(changes: SimpleChanges): void {
    ngHelper.ifChanged(changes, 'userInfo', (userInfo: IPaymentInfo) => {
      if (userInfo) {
        this.info = { ...userInfo };
      }
    });
  }

  public registerForm(form: NgForm) {
    if (!this.form) {
      this.addSubscriber(form.valueChanges.subscribe(() => {
        this.emitStatus();
      }));

      this.form = form;
      this.emitStatus();
    }
  }

  public emitStatus(updatedFields: { [key: string]: any } = null) {
    setTimeout(() => {
      this.isValid = this.form.valid;
      this.onValidUpdated.emit(this.isValid);
      const val = this.form.value;

      // we have to do that as we want to have good names on fields which are prefiled by browsers
      const fieldsMap = {
        full_name: 'userName',
        email: 'userEmail',
        company_name: 'userCompanyName',
        phone: 'userPhone'
      };
      // adding new fields with right keys
      for (const key in val) {
        if (val.hasOwnProperty(key) && fieldsMap[key]) {
          val[fieldsMap[key]] = val[key];
        }
      }
      // removing fields which are not relevant
      for (const key in fieldsMap) {
        delete val[key];
      }

      if (updatedFields) {
        Object.getOwnPropertyNames(updatedFields).forEach(key => val[key] = updatedFields[key]);
      }

      this.onInfoUpdated.emit(val);
    });
  }

  public companySelected(selectedCompany: IUserCompany) {
    this.info.userCompanyName = selectedCompany.legalCompany.name;

    this.emitStatus({
      userCompanyName: selectedCompany.legalCompany.name,
      invoiceCompanyId: selectedCompany.id,
      invoiceCompanyOrgNumber: selectedCompany.legalCompany.orgNumber,
      invoiceCompanyDiscount: selectedCompany.discount,
      invoiceCompanyCountry: selectedCompany.legalCompany.country
    });

    this.onCompanySelected.emit(selectedCompany);
  }

  public clearCompany() {
    this.emitStatus({
      userCompanyName: null,
      invoiceCompanyId: null,
      invoiceCompanyOrgNumber: null,
    });
  }
}
